exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clearfix{clear:both}#render-container{float:left;width:100%}#render-container p:empty{display:none}#render-container>.data-module,#render-container>[data-module],.form-group>.data-module,.form-group>[data-module]{margin-left:-15px;margin-right:-15px;width:calc(100% + 30px)}.mbgf-alignleft{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/markdownwrapper/markdownwrapper.styl
// module id = 7
// module chunks = 0 1